import { FC, useState } from 'react';
import { FOLDER_DIRECTORIES } from '../../../constants/folder';
import Icon from '../../icon/icon';
import AddToFolderModal from '../add-to-folders-modal/add-to-folders-modal';
import './add-to-folder-button.scss';

type AddToFolderButtonProps = {
    directory: FOLDER_DIRECTORIES;
    items: Material[];
    active?: boolean;
    children?: React.JSX.Element;
    height?: number;
    icon?: 'folder' | 'folder-filled' | 'folder-with-arrow' | 'folder-bounding-box';
    text?: string;
    onMouseEnter?: VoidFunction;
    onMouseLeave?: VoidFunction;
    onClick?: () => void;
    selectAllSelection?: SelectAllSelection;
};

const AddToFolderButton: FC<AddToFolderButtonProps> = ({
    items,
    text = '',
    directory,
    icon = 'folder',
    active = false,
    height = 24,
    children,
    onMouseEnter,
    onMouseLeave,
    onClick,
    selectAllSelection
}) => {
    const [showModal, setShowModal] = useState(false);

    const handleClick = () => {
        onClick?.();
        setShowModal(true);
    };

    const hideModal = () => {
        setShowModal(false);
    };

    return (
        <span className='cursor-pointer folder-button'>
            <span onClick={handleClick} onMouseEnter={onMouseEnter} onMouseLeave={onMouseLeave}>
                {children || <Icon name={icon} height={height} text={text} active={active} />}
            </span>
            {showModal && (
                <AddToFolderModal
                    directory={directory}
                    onClose={hideModal}
                    items={items}
                    selectAllSelection={selectAllSelection}
                />
            )}
        </span>
    );
};

export default AddToFolderButton;
